export enum Role {
  SuperAdmin = 'SUPER_ADMIN',
  Recruiter = 'RECRUITER',
  Owner = 'OWNER',
  Taqe = 'TAQE',
  Master = 'MASTER'
}
